import {
  Box, Button, Flex, Text
} from '@huspy/briks-web';
import { VStack } from '@huspy/styled-system/jsx';
import { BaseSlido } from '@modules/core/components/BaseSlido';
import { CaseCreationVaultFillFormsRoute } from '@modules/opportunities/presentation/routes';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation, Trans } from 'react-i18next';
import { Image } from '@mantine/core';
import { imagesPath } from '@shared/css.const';

export const VaultReviewSlido = ({
  opened,
  close,
  opportunityId,
  vaultError,
}: {
  opened: boolean;
  close: () => void;
  opportunityId: string;
  vaultError: Record<string, string>;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const numbOfErrors = Object.keys(vaultError).length;

  return (
    <BaseSlido
      title={ (
        <VStack gap='spacing-1' alignItems='flex-start' p='8'>
          <Text size='3xl' weight='medium'>
            {t('vault.vaultReviewSlido.title')}
          </Text>
        </VStack>
      ) }
      footer={ (
        <Flex w='100%' justify='end' align='end'>
          <Button
            size='md'
            fontSize='md'
            onClick={ () => {
              navigate({
                to: CaseCreationVaultFillFormsRoute.to,
                params: { opportunityId },
                hash: 'validate',
              });
            } }
          >
            {t('vault.vaultReviewSlido.goToVault')}
          </Button>
        </Flex>
      ) }
      opened={ opened }
      close={ close }
    >
      <Flex direction='column' h='100%' justify='space-between'>
        <Flex bg='white' p='4' borderRadius='4' direction='column' my='2'>
          <Box w='100%' mb='2'>
            <Image src={ `${imagesPath}/missing-fields.png` } w='100%' />
          </Box>
          <Text size='2xl' my='2'>
            {t('vault.vaultReviewSlido.beforeSubmit')}
          </Text>
          <Text size='md' my='2' color='text-secondary'>
            {t('vault.vaultReviewSlido.errorsInVault')}
          </Text>
          <Text size='md' my='2' color='text-error-primary_alt'>
            {t('vault.vaultReviewSlido.fieldsHaveErrors', { count: numbOfErrors })}
          </Text>
          <Box my='4' />
          <Text size='lg' my='2'>
            {t('vault.vaultReviewSlido.howToResolve')}
          </Text>
          <Flex mx='2' direction='column'>
            <Text size='md' my='2' color='text-secondary'>
              <Trans i18nKey='vault.vaultReviewSlido.step1' components={ { strong: <strong /> } } />
            </Text>
            <Text size='md' my='2' color='text-secondary'>
              {t('vault.vaultReviewSlido.step2')}
            </Text>
            <Text size='md' my='2' color='text-secondary'>
              {t('vault.vaultReviewSlido.step3')}
            </Text>
            <Text size='md' my='2' color='text-secondary'>
              {t('vault.vaultReviewSlido.step4')}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </BaseSlido>
  );
};
